define([
        "dojo/_base/lang",
        "MW/toolstrip/hashes/componentproperties/properties/TagProperty",
        "MW/toolstrip/hashes/componentproperties/properties/TypeProperty",
        "MW/toolstrip/hashes/componentproperties/properties/VerifyComponentProperty",
        "./NumericValueProperty",
        "./RegionProperty",
        "./WidthProperty",
        "../TypeConstants"
    ],
    function (lang, TagProperty, TypeProperty, VerifyComponentProperty, NumericValueProperty, RegionProperty, WidthProperty, TypeConstants) {
        var hash = {};

        hash[TypeConstants.STATUS_PROGRESS_BAR] = lang.mixin({},
            TagProperty, TypeProperty, NumericValueProperty, RegionProperty, WidthProperty,
            {
                indeterminate: new VerifyComponentProperty({
                    type: "boolean",
                    defaultValue: false,
                    notInAction: true,
                    required: false
                }),
                colorStyle: new VerifyComponentProperty({
                    type: "string",
                    notInAction: true,
                    defaultValue: "Info",
                    required: false
                }),
                showPercentage: new VerifyComponentProperty({
                    type: "boolean",
                    defaultValue: false,
                    notInAction: true,
                    required: false
                })
            });

        return hash;
    });
